import React from 'react'
import { Field } from 'formik'
import { Form, Col } from '_zari/core'

const GuiaRemisionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='GUÍA REMISIÓN' htmlFor='input-guiaRemision' md={3} />
      <Col md={9}>
        <Field name='guiaRemision'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-guiaRemision'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              placeholder='Nro. guía de remisión'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(GuiaRemisionFormGroup)
